export default __webpack_public_path__ + "static/char-s-43-zh-Hans-a0b9bd5ca2b3bb2d17c21685fcb43878.png";